export class DownTimeDetailsModel {
    downTimeCause: string;
    affectedAssetsCount: number;

    constructor(downTimeCause: string,affectedAssetsCount: number){
        this.downTimeCause = downTimeCause;
        this.affectedAssetsCount = affectedAssetsCount;

    }
}